module.exports = __webpack_public_path__ + "static/media/gradient-bg.e46470f3.png";